module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/home_active-338111a718e5baf4c03a2fa6018ab252.png";